<template>
  <div id="search-bar-wrapper">
    <div id="search-bar" class="mx-auto d-flex justify-end">
      <input
        type="text"
        placeholder="I'm looking for...."
        v-model="searchKeywords"
        @keyup.enter="performSearch"
      />
      <div id="search-button" class="text-center" @click="performSearch">SEARCH</div>
      <div id="search-close-wrapper" class="d-flex" @click="taggleSearchBar">
        <div id="search-close-button" class="font-size-12">CLOSE</div>
        <v-icon small color="#d9d9d9">close</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { TAGGLE_SEARCH_BAR } from "../../utils/mutationType";
import { mapMutations } from "vuex";

export default {
  data: () => ({
    searchKeywords: ""
  }),

  methods: {
    ...mapMutations("nav", {
      taggleSearchBar: TAGGLE_SEARCH_BAR
    }),

    performSearch() {
      window.location.href = this.searchUrl;
    }
  },

  computed: {
    searchUrl() {
      return "/search?k=" + this.searchKeywords;
    }
  }
};
</script>


<style scoped>
#search-bar-wrapper {
  width: 100%;
  z-index: 2;
  top: var(--nav-height);
  position: absolute;
  background-color: #333333;
}

#search-bar {
  max-width: 800px;
}

#search-bar > input[type="text"] {
  width: 753px;
  height: 73px;
  display: inline-block;
  caret-color: white;
  color: white;
  font-size: 18px;
}

::-webkit-input-placeholder {
  font-size: 18px;
  font-weight: 550;
  color: #7f7f7f;
}

::-moz-placeholder {
  font-size: 18px;
  font-weight: 550;
  color: #7f7f7f;
}

:-ms-input-placeholder {
  font-size: 18px;
  font-weight: 550;
  color: #7f7f7f;
}

:-moz-placeholder {
  font-size: 18px;
  font-weight: 550;
  color: #7f7f7f;
}

#search-bar > input[type="text"]:focus {
  outline: none;
}

#search-button {
  height: 73px;
  width: 144px;
  background-color: #e2211c;
  color: white;
  line-height: 73px;
  font-weight: 500;
  cursor: pointer;
}

#search-close-wrapper {
  cursor: pointer;
  position: absolute;
  right: 40px;
  margin-top: 10px;
}

#search-close-button {
  border-bottom: #7a7a7a 3px solid;
  color: #d9d9d9;
}
</style>